import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { SearchBar } from '../ui/SearchBar.js';
import { api } from '../api/client.js';
import type { ModelSummary } from '@wml-crm/shared';

function firstLetter(s: string): string {
  const c = s.trim().charAt(0);
  return c ? c.toUpperCase() : '?';
}

export function HomePage() {
  const [models, setModels] = useState<ModelSummary[]>([]);

  useEffect(() => {
    api<ModelSummary[]>('/api/models')
      .then(setModels)
      .catch(() => setModels([]));
  }, []);

  const totalAccounts = models.reduce((s, m) => s + m.accountCount, 0);
  const totalPosts = models.reduce((s, m) => s + m.postCount, 0);
  const recentModels = models.slice(0, 12);

  return (
    <div className="home-inner">
      <div className="hero">
        <div className="hero-eyebrow">
          <span className="hero-eyebrow-dot" />
          Панель охватов WML
        </div>
        <h1>
          Метрики моделей<br />в одном <span className="accent">чистом</span> виде
        </h1>
        <p>Найди модель по имени, посмотри график охватов её постов и детали каждой публикации.</p>
        <SearchBar autoFocus />
      </div>

      <div className="stats-row">
        <div className="stat-card">
          <div className="stat-label">Моделей в системе</div>
          <div className="stat-value stat-accent">{models.length}</div>
        </div>
        <div className="stat-card">
          <div className="stat-label">Твиттер-аккаунтов</div>
          <div className="stat-value">{totalAccounts}</div>
        </div>
        <div className="stat-card">
          <div className="stat-label">Постов собрано</div>
          <div className="stat-value">{totalPosts}</div>
        </div>
      </div>

      {recentModels.length > 0 && (
        <>
          <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', margin: '28px 0 12px' }}>
            <div className="section-title" style={{ margin: 0 }}>Быстрый доступ</div>
            <Link to="/models" style={{ color: 'var(--text-muted)', fontSize: 13, fontWeight: 500 }}>
              показать все →
            </Link>
          </div>
          <div className="model-grid">
            {recentModels.map((m) => (
              <Link key={m.id} to={`/model/${m.id}`} className="model-card">
                <div className="model-avatar">{firstLetter(m.displayName)}</div>
                <div className="info">
                  <div className="name">{m.displayName}</div>
                  <div className="meta">{m.accountCount} акк. · {m.postCount} постов</div>
                </div>
              </Link>
            ))}
          </div>
        </>
      )}
    </div>
  );
}
